import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  url: string;
  displayPdf: boolean;
};

function mapResponse(response: ApiResponse) {
  return response;
}

const endpoint = new FetchEndpoint({
  urlFactory: (filename: string, download: boolean) =>
    `/files/${filename}${download ? '?download=true' : ''}`,
  mapResponse,
});

// Exports

export const cmsApiIsomorphicFetchFile = endpoint.createIsomorphicFetchFn();
